import React from 'react';
import {Modal} from '@forecast-it/design-system';
import {FormattedHTMLMessage, FormattedMessage} from 'react-intl';

type ExitActionBarModalProps = {
	closeModal: () => void;
	callback: () => void;
};

const ExitActionBarModal = ({closeModal, callback}: ExitActionBarModalProps): React.JSX.Element => {
	const onClickConfirm = () => {
		callback();
		closeModal();
	};
	return (
		<Modal size={Modal.SIZE.SMALL} onCloseModal={closeModal}>
			<Modal.Title>
				<FormattedMessage id={'action_bar.title'} />
			</Modal.Title>
			<Modal.Content>
				<FormattedHTMLMessage id={'action_bar.description'} />
			</Modal.Content>
			<Modal.Footer>
				<Modal.PrimaryFooterButton onPress={onClickConfirm} dataCy={'modal-btn-confirm'}>
					<FormattedMessage id="common.confirm" />
				</Modal.PrimaryFooterButton>
				<Modal.SecondaryFooterButton onPress={closeModal}>
					<FormattedMessage id="common.go_back" />
				</Modal.SecondaryFooterButton>
			</Modal.Footer>
		</Modal>
	);
};

export default ExitActionBarModal;
